<template>
  <div :class="dividerClasses"></div>
</template>

<script>
export default {
  name: 'BaseDivider',
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dividerClasses() {
      return [
        'divider',
        {
          'divider--vertical': this.vertical,
          'divider--dark': this.dark
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../scss/variables' as *;

.divider {
  background: linear-gradient(90deg, transparent 0%, #e2e8f0 20%, #e2e8f0 80%, transparent 100%);

  &:not(.divider--vertical) {
    height: 1px;
    width: 100%;
    margin: $spacing-2 $spacing-2;
  }

  &--vertical {
    width: 1px;
    height: 100%;
    margin: 0 $spacing-4;
    background: linear-gradient(180deg, transparent 0%, #e2e8f0 20%, #e2e8f0 80%, transparent 100%);
  }

  &--dark {
    background: linear-gradient(90deg, transparent 0%, #cbd5e1 20%, #cbd5e1 80%, transparent 100%);
  }
}
</style>
